import * as yup from "yup";

export const createCropValidationSchema = () =>
  yup.object().shape({
    farmland: yup.string().required("Farm is required"),
    commodity: yup.string().required("Crop type is required"),
    sowing_date: yup.date().required("date is required"),
    seed_type: yup.string().notRequired(),
    seed_source: yup.string().notRequired(),
    seed_quantity: yup
      .number()
      .nullable()
      .notRequired()
      .typeError("Seed quantity must be a number")
      .positive("Seed quantity must be positive"),
    sapling_quantity: yup
      .number()
      .nullable()
      .notRequired()
      .typeError("sampling quantity must be a number")
      .positive("sampling quantity must be positive"),
    estimated_harvest: yup
      .number()
      .nullable()
      .notRequired()
      .typeError("Estimated harvest amount must be a number")
      .positive("Estimated harvest amount must be positive"),
    estimated_harvest_date: yup
      .date()
      .nullable()
      .notRequired()
      .typeError("Estimated harvest date must be a valid date"),
    sowing_file: yup.mixed().notRequired(),
    is_ebc_contest: yup.boolean().notRequired(),
    is_ebc_applied: yup.boolean().notRequired(),
    ebc_quantity: yup
      .number()
      .nullable()
      .when("is_ebc_applied", {
        is: true,
        then: (schema) =>
          schema
            .required("EBC quantity is required when EBC is applied")
            .typeError("EBC quantity must be a number")
            .positive("EBC quantity must be positive"),
        otherwise: (schema) => schema.notRequired(),
      }),
  });

export const createPlantationValidationSchema = () =>
  yup.object().shape({
    farmland: yup.string().required("Farm is required"),
    commodity: yup.string().required("Crop type is required"),
    nursery_name: yup.string().required("Nursery name is required"),
    nursery_location: yup.string().required("Nursery Location is required"),
    plantation_method: yup.string().required("Plantation Method is required"),
    pit_size: yup.string().notRequired(),
    plant_count: yup.string().notRequired(),
    sowing_date: yup.date().required("Sowing date is required"),
    sowing_file: yup.mixed().notRequired(),
  });

export const farmValidationSchema = () =>
  yup.object().shape({
    farm_name: yup.string().required("Farm name is required"),
    regulator: yup.string().notRequired(),
    land_record_number: yup.string().notRequired(),
    pin_code: yup.string().length(6, "PIN/ZIP code must be 6 digits"),
    address_line1: yup.string(),
    address_line2: yup.string(),
    irrigation_source: yup
      .array()
      .of(yup.string())
      .required("Select at least one irrigation source")
      .min(1, "Select at least one irrigation source"),
    irrigation_system: yup
      .array()
      .of(yup.string())
      .required("Select at least one irrigation system")
      .min(1, "Select at least one irrigation system"),
    soil_texture: yup.string().required("Soil texture is required"),
    owner_type: yup.string().required("Owner type is required"),
    farm_doc: yup.mixed().notRequired(),
    land_doc: yup.mixed().notRequired(),
    owner_name: yup.string().required("Owner name is required"),
    area: yup.number().required("Area is required"),

    farm_photo: yup.mixed().notRequired(),
  });

export const FpoMemberValidationSchema = () =>
  yup.object().shape({
    full_name: yup.string().required("Name is required"),
    mobile: yup
      .string()
      .matches(/^[0-9]+$/, "Mobile number must contain only digits")
      .required("Mobile number is required"),
    aadhar_number: yup
      .string()
      .matches(/^[0-9]{12}$/, "Aadhar number must be 12 digits")
      .required("Aadhar number is required"),
    aadhar_card: yup.mixed().required("Aadhar card is required"),
    // pan_number: yup
    //   .string()
    //   .matches(
    //     /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
    //     "PAN number must be in the format ABCDE1234F"
    //   )
    //   .notRequired("PAN number is required"),
    pan_card: yup.mixed().notRequired("PAN card is required"),
    designation: yup.string().required("Member type is required"),
    address: yup.string().required("Address is required"),
  });

export const organizationValidationSchema = () =>
  yup.object().shape({
    name: yup.string().required("Organization Name is required"),
    year_of_incorporation: yup
      .number()
      .nullable()
      .typeError("Year of Incorporation must be a number")
      .required("Year of Incorporation is required")
      .integer("Year of Incorporation must be an integer")
      .min(1900, "Year of Incorporation cannot be earlier than 1900")
      .max(
        new Date().getFullYear(),
        "Year of Incorporation cannot be in the future"
      ),
    incorporation_certificate: yup
      .mixed()
      .required("Incorporation Certificate is required"),
    // pan_number: yup
    //   .string()
    //   .matches(
    //     /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
    //     "PAN number must be in the format ABCDE1234F"
    //   )
    //   .required("PAN number is required"),
    // pan_card: yup.mixed().required("PAN Card is required"),
    // gst_number: yup
    //   .string()
    //   .matches(
    //     /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[0-9A-Z]{1}$/,
    //     "GST number must be in the format 22ABCDE1234F1Z1"
    //   )
    //   .required("GST Number is required"),
    // gst_certificate: yup.mixed().required("GST Certificate is required"),
    address: yup.string().required("Address is required"),
    farmer_count: yup
      .number()
      .nullable()
      .required("Total Farmers is required")
      .integer("Total Farmers must be an integer")
      .positive("Total Farmers must be a positive number"),
  });

// Fpo Farmer Profile

export const FpoFarmerProfileValidationSchema = () =>
  yup.object().shape({
    full_name: yup.string().required("Name is required"),
    mobile: yup
      .string()
      .matches(/^[0-9]+$/, "Mobile number must contain only digits")
      .required("Mobile number is required"),
    address: yup.string().required("Address is required"),
    // aadhar_number: yup
    //   .string()
    //   .matches(/^[0-9]{12}$/, "Aadhar number must be 12 digits")
    //   .required("Aadhar number is required"),
    // pan_number: yup
    //   .string()
    //   .matches(
    //     /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
    //     "PAN number must be in the format ABCDE1234F"
    //   )
    //   .required("PAN number is required"),
    farming_since_year: yup
      .number()
      .required("Farming since year is required")
      .positive("Farming since year must be positive")
      .integer("Farming since year must be an integer"),
    crops_covered: yup.string().required("Crops covered is required"),
  });

export const LoanRequestValidationSchema = () =>
  yup.object().shape({
    lender: yup.string().required("Lender is required"),
    amount: yup
      .number()
      .required("Amount is required")
      .positive("Amount must be positive"),
    loan_type: yup.string().required("Loan Type is required"),
    pincode: yup.string().required("PIN Code is required"),
    revenue: yup
      .number()
      .required("Revenue is required")
      .positive("Revenue must be positive"),
  });

export const buyerRequirementValidationSchema = () =>
  yup.object().shape({
    commodity: yup.string().required("Commodity is required"),
    quantity: yup.number().required("Quantity is required"),
    max_price: yup.number().required("Price is required"),
    date_needed: yup.date().required("Date is required"),
    responder_type: yup.string().required("Responder type is required"),
    pin_code: yup.number().required("PIN/ZIP code is required"),
    quality_requirement: yup.string().required("Quality is required"),
  });

export const buyerProfileValidationSchema = () =>
  yup.object().shape({
    brand_name: yup.string().required("Brand Name is required"),
    headquarter_location: yup
      .string()
      .required("Headquarter Location is required"),
    geographical_presence: yup
      .string()
      .required("Geographical Presence is required"),
    products_of_interest: yup
      .string()
      .required("Products Of Interest is required"),
    nature_of_interest: yup.string().required("Nature Of Interest is required"),
    contact_person_name: yup
      .string()
      .required("Contact Person Name is required"),
    contact_person_phone_number: yup
      .string()
      .required("Contact Person Phone Number is required"),
  });

export const createSoilTestValidationSchema = (testMode = "device") => {
  const baseSchema = {
    farm_land: yup.string().required("Farm is required"),
  };

  if (testMode === "manual") {
    return yup.object().shape({
      ...baseSchema,
      ph: yup
        .number()
        .required("pH level is required")
        .min(0, "pH must be at least 0")
        .max(14, "pH must be at most 14"),
      nitrogen: yup
        .number()
        .required("Nitrogen level is required")
        .min(0, "Nitrogen must be a positive number"),
      phosphorus: yup
        .number()
        .required("Phosphorus level is required")
        .min(0, "Phosphorus must be a positive number"),
      potassium: yup
        .number()
        .required("Potassium level is required")
        .min(0, "Potassium must be a positive number"),
      organic_carbon: yup
        .number()
        .required("Organic Carbon is required")
        .min(0, "Organic Carbon must be a positive number")
        .max(10, "Organic Carbon seems too high"),
      humidity: yup
        .number()
        .optional()
        .min(0, "Humidity must be at least 0")
        .max(100, "Humidity cannot exceed 100%"),
      temperature: yup
        .number()
        .optional()
        .min(-50, "Temperature seems too low")
        .max(100, "Temperature seems too high"),
    });
  }

  return yup.object().shape(baseSchema);
};

export const createExternalSoilTestValidationSchema = () =>
  yup.object().shape({
    report_id: yup.string().required("Identifier is required"),
    name: yup.string().required("Name is required"),
    mobile: yup.string().required("Mobile number is required"),
    pincode: yup.string().required("PIN code is required"),
    state: yup.string().required("State is required"),
    district: yup.string().required("District is required"),
    postoffice: yup.string().required("Post Office is required"),
    address_line1: yup.string().required("Address is required"),
    village: yup.string().required("Village is required"),
  });

export const soilTestReportValidationSchema = () =>
  yup.object().shape({
    farm: yup
      .number()
      .required("Farm selection is required")
      .transform((value, originalValue) => {
        return originalValue === "" ? undefined : value;
      }),
    crop: yup.string().required("Crop selection is required"),
  });

export const externalSoilTestReportValidationSchema = () =>
  yup.object().shape({
    farmer_name: yup.string().required("Farmer Name is required"),
    mobile: yup
      .string()
      .required("Mobile number is required")
      .length(10, "Mobile Number must be 10 digits"),
    farm_area: yup
      .number()
      .required("Farm Area is required")
      .transform((value, originalValue) =>
        originalValue === "" ? undefined : value
      )
      .moreThan(0, "Farm area must be greater than 0"),
    soil_type: yup.string().required("Soil Type is required"),
    crop_name: yup.string().required("Crop Type is required"),
    sowing_date: yup
      .mixed()
      .required("Sowing Date is required")
      .test(
        "is-dayjs",
        "Invalid date",
        (value) => value && value.isValid && value.isValid()
      ),
    pincode: yup
      .string()
      .required("PIN code is required")
      .length(6, "Pincode must be 6 digits"),
    state: yup.string().required("State is required"),
    district: yup.string().required("District is required"),
    postoffice: yup.string().required("Post Office is required"),
    address_line1: yup.string().required("Address is required"),
  });

export const fpoInterestValidationSchema = yup.object().shape({
  fpo_name: yup.string().required("Name is required"),
  contact_person_name: yup.string().required("Contact person name is required"),
  contact: yup
    .number()
    .typeError("Mobile number must be a number")
    .required("Mobile number is required"),
  location: yup.string().required("Location is required"),
  total_number_of_farmers: yup
    .number()
    .positive("Total number of farmers must be positive")
    .typeError("Total number of farmers must be a number")
    .required("Total number of farmers is required"),
  total_acreage: yup
    .number()
    .positive("Total acreage must be positive")
    .typeError("Total acreage must be a number")
    .required("Total acreage is required"),
  interested_in: yup.string().required("Interest is required"),
  commodity_details: yup
    .array()
    .min(1, "At least one commodity detail is required")
    .required("Commodity details are required"),
});

export const personalInformationSchema = yup.object().shape({
  full_name: yup.string().required("Full name is required"),
  phone_number: yup.string().required("Phone number is required"),
  alternate_phone_number: yup
    .string()
    .required("Alternate Phone number is required")
    .length(10, "Number must be 10 digits"),
  pin_code: yup
    .string()
    .required("Pincode is required")
    .length(6, "Pincode must be 6 digits"),
  village: yup.string().required("Village is required"),
  address_line1: yup.string().required("Address is required"),
  address_line2: yup.string(),
  kyc_details: yup.object().shape({
    aadhar_number: yup.string().required("Aadhar number is required"),
    pan_number: yup.string().required("PAN number is required"),
  }),
});

export const farmerValidationSchema = yup.object().shape({
  full_name: yup.string().required("Full name is required"),
  phone_number: yup
    .string()
    .required("Phone number is required")
    .length(10, "Number must be 10 digits"),
  alternate_phone_number: yup.string().length(10, "Number must be 10 digits"),
  pin_code: yup
    .string()
    .required("Pincode is required")
    .length(6, "Pincode must be 6 digits"),
  village: yup.string(),
  address_line1: yup.string().required("Address is required"),
  address_line2: yup.string(),
  email_id: yup.string().email(),

  kyc_details: yup.object().shape({
    aadhar_image: yup.mixed().notRequired(),
    pan_image: yup.mixed().notRequired(),

    aadhar_number: yup
      .string()
      .test(
        "aadhar-validation",
        "Aadhar number must be 12 digits",
        function (value) {
          const { aadhar_image } = this.parent;
          if (
            (!value && !aadhar_image) ||
            (value && value.length === 12) ||
            (aadhar_image && value && value.length === 12)
          )
            return true;
          return false;
        }
      ),

    pan_number: yup
      .string()
      .test(
        "pan-validation",
        "PAN number must be 10 characters",
        function (value) {
          const { pan_image } = this.parent;
          if (
            (!value && !pan_image) ||
            (value && value.length === 10) ||
            (pan_image && value && value.length === 10)
          )
            return true;
          return false;
        }
      ),
  }),
});

export const biocharOrderPlaceValidationSchema = (orderType = "farmer") =>
  yup.object().shape({
    ...(orderType === "farmer"
      ? {
          farmer_id: yup.number().required("Farmer is required"),
          farm_id: yup.number().required("Farm is required"),
        }
      : {
          institution_name: yup
            .string()
            .required("Institution Name is required"),
          institution_phone_number: yup
            .string()
            .length(10, "Phone Number should be of length 10")
            .required("Institution Phone Number is required"),
        }),
    source_plant: yup.number().required("Source Plant is required"),
    village: yup.string().required("Village is required"),
    requested_quantity: yup
      .number()
      .transform((value, originalValue) => {
        return originalValue === "" ? undefined : value;
      })
      .min(0, "Enter the Value Greater than 0")
      .required("Quantity is required"),
    cost_per_kg: yup
      .number()
      .transform((value, originalValue) => {
        return originalValue === "" ? undefined : value;
      })
      .min(0, "Enter the Value Greater than 0")
      .required("cost_per_kg is required"),
    delivery_charges: yup
      .number()
      .transform((value, originalValue) => {
        return originalValue === "" ? undefined : value;
      })
      .min(0, "Enter the Value Greater than 0")
      .required("Delivery Charges is required"),
    packaging_charges: yup
      .number()
      .transform((value, originalValue) => {
        return originalValue === "" ? undefined : value;
      })
      .min(0, "Enter the Value Greater than 0")
      .required("Packaging Charges is required"),
    commission: yup
      .number()
      .transform((value, originalValue) => {
        return originalValue === "" ? undefined : value;
      })
      .min(0, "Enter the Value Greater than 0")
      .required("Commission is required"),
  });

export const biocharRequestValidationSchema = () =>
  yup.object().shape({
    name: yup.string().required("Name is required"),
    farm_id: yup.string().notRequired(),
    organization: yup.string().notRequired(), // Already not required, keeping as is
    email: yup.string().email("Invalid email format").notRequired(), // Changed from required to notRequired
    phone_number: yup
      .string()
      .required("Phone number is required")
      .length(10, "Number must be 10 digits"),
    pincode: yup.string().required("PIN code is required"),
    state: yup.string().required("State is required"),
    district: yup.string().required("District is required"),
    postoffice: yup.string().required("Post Office is required"),
    address_line1: yup.string().required("Address is required"),
    village: yup.string().required("Village is required"),
    quantity_required: yup.string().required("Quantity is required"),
  });
